import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { RxAuthService } from '../rx-auth/rx-auth.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  permission_list: Array<number> = [];

  private apiUrlAlphabetic = `${environment.backend_base}main/search/alphabetic_search/`;
  private apiUrl = `${environment.backend_base}main/search/`;
  private newPubListURL = `${this.apiUrl}newest_lists/`;
  private filterOptionsURL = `${this.apiUrl}get_all_filter_options/`;

  constructor(
    private http: HttpClient,
    private router: Router,
    private auth: RxAuthService
  ) {}

  search(query: string, results_index: number | null = 0, filters: any | null = null): Observable<any> {
    const body = { search: query, results_index: results_index, filters: filters };
    return this.http.post<any>(this.apiUrl, body, this.auth.httpOptions);
  }

  alphabeticSearch(query: string, results_index:  number | null = 0, filters: any | null = null): Observable<any> {
    const body = { letter: query, results_index: results_index, filters: filters };
    return this.http.post<any>(
      this.apiUrlAlphabetic,
      body,
      this.auth.httpOptions
    );
  }

  searchNewestPubLists(): Observable<any> {
    const body = {};
    return this.http.post<any>(this.newPubListURL, body, this.auth.httpOptions);
  }

  getAllFilterOptions(): Observable<any> {
    const body = {};
    return this.http.post<any>(this.filterOptionsURL, body, this.auth.httpOptions);
  }
}
